import services from './../../services/service'; // Service Class
import SecondHeader from './../Second-Header/index.vue'; // Second Header
import Sidebar from './../Sidebar/index.vue'; // Sidebar
import MainFooter from './../Main-Footer/index.vue'; // Main Footer
import CreateThread from '../CreateThread.vue';
import SearchBar from '../SearchBar.vue';

let service = new services();

export default {
    name: 'Cnsurveys',
    data () {
        return {
            user:{},
            survey: {},
            surveys: [],
            answer: [],
            pag_intv: service.pageIntv,
            current_page: 0,
            siteUrl:service.siteUrl+"?title="
        }
    },
    components: {
       'second-header': SecondHeader,
        'sidebar': Sidebar,
        'main-footer': MainFooter,      
        'create-thread': CreateThread,
        'search-bar': SearchBar
    },
    methods: {
        copyLink(survey) {
            this.$clipboard(this.siteUrl+survey.cnsurvey_title_url)
              var btn = $('.linky').tooltip({
                  trigger: 'click',
                  placement: 'bottom'
                });
              this.setTooltip(btn, 'Copied to Clipboard');
              this.hideTooltip(btn);
          },
          setTooltip(btn, message) {
              btn.tooltip('hide')
                .attr('data-original-title', message)
                .tooltip('show');
            },
            
          hideTooltip(btn) {
              setTimeout(function() {
                btn.tooltip('hide');
              }, 1000);
          },
         //settings
        preset() { //must login
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
           if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                            this.getSurveys(0,this.pag_intv); //getSurveys
                         }, this);
                        }else {
                            this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
            
        },

        preset2() { //must not login, provide CNUser ID
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
           if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                            this.getSurveys(0,this.pag_intv); //getSurveys
                         }, this);
                    }else {
                        // this.$router.push('login');
                        if(localStorage.getItem("cgt") == null){
                            this.prepareCNuserGuestID();
                        }else{
                            this.user.user_id = localStorage.getItem("cgt");
                            this.getSurveys(0,this.pag_intv); //getSurveys
                        }
                    }
                }).catch((err) => {
                    if(localStorage.getItem("cgt") == null){
                        this.prepareCNuserGuestID();
                    }else{
                        this.user.user_id = localStorage.getItem("cgt");
                        this.getSurveys(0,this.pag_intv); //getSurveys
                    }
                })
            }else {
                if(localStorage.getItem("cgt") == null){
                    this.prepareCNuserGuestID();
                }else{
                    this.user.user_id = localStorage.getItem("cgt");
                    this.getSurveys(0,this.pag_intv); //getSurveys
                }
            }
            
        },

        prepareCNuserGuestID(){
            service.prepareCNuserGuestID(this).then(response => {
                if(response.body.status == 200) {
                    this.user.user_id = response.body.data;
                    localStorage.setItem("cgt",this.user.user_id);//log current page
                    this.getSurveys(0,this.pag_intv); //getSurveys
                }
            }).catch((err) => {
                //log err
            })
        },

        //--//settings
        isActive(page){
            if(page == this.current_page){
                return true;
            }
        },

        // Get all surveys

        // getSurveys() {
        //     service.allSurveys(this).then((res) => {
        //         this.surveys = res.body.data;
        //     })
        // },

        getSurveys(offset,items) {
            service.getAllSurveys(this,offset,items).then((res) => {
                this.surveys = res.body.data;
                if((res.body.data_count % this.pag_intv)){
                    this.surveys.count_range = (Math.floor(res.body.data_count/this.pag_intv)+1);
                }else{this.surveys.count_range = Math.floor(res.body.data_count/this.pag_intv);}
                //this.current_page = items;
                if(offset == 0){//ist page
                    this.current_page = 1;
                }else{
                    this.current_page = items; //and we are back!
                }
            })
        },

        // next(sv,i){
        //     //this.surveys[sv].cnsurvey_question_index++;
        //     if((i != (this.surveys[sv].cnsurvey_question_index + 1)) && (i != 0)){
        //         this.surveys[sv].cnsurvey_question_index = 0;
        //     }else{
        //         this.surveys[sv].cnsurvey_question_index++;
        //     }
            
        // },
        next(sv,i){
            if(this.surveys[sv].cnsurveys_questions[i+1] == undefined){
                this.surveys[sv].cnsurvey_question_index = 0;
                //activate register pop up if not logged in
                if(localStorage.getItem("cityneeds_token") == null){
                    $('#guest-poll').modal('show');
                }
           }else{
                this.surveys[sv].cnsurvey_question_index++;
            }
          
        },
        //check if this user has polled this survey
        check_if_user_has_polled(survey_answers) {
            let loop_count = 0;
            if((survey_answers != null)){
                survey_answers.forEach(function(element) {
                    if(this.user.user_id == element.cnsurvey_answer_user){
                        loop_count = 1;
                    }
                }, this);
                if(loop_count == 1){
                    return true;
                }
            }else{
                 return false;
            }
        },
        //get the answers for each option
        get_option_answer(option,survey_answers){
            let option_count = 0;
            if((survey_answers != null)){
                survey_answers.forEach(function(element) {
                    if(option == element.cnsurvey_answer_option){
                         option_count++;
                        }
                }, this);
                return option_count;
            } else{
                return 0;
            }
            
           
        },
        // Answer survey
        fillSurvey(survey,survey_question,survey_question_index,option) {
           this.survey = survey;
          
            var data = {
                cnsurvey_answer_survey_question: survey_question.cnsurvey_question_id,
                cnsurvey_answer_user: this.user.user_id || 0, //reconsider this 
                cnsurvey_answer_option: option
            }
            service.surveyAns(this, data).then((res) => {
                if (res.status == 201) { 
                    toastr.success("You've Polled", "Thumbs Up!");
                    //location.reload();
                   // this.survey.cnsurveys_answers = res.body.cnsurvey_answers;
                    this.survey.cnsurveys_questions[survey_question_index].cnsurveys_answers = res.body.cnsurvey_answers;
                    //then call the check
                    this.survey.cnsurveys_questions[survey_question_index].polled = true;
                }else{
                    toastr.warning("Couldn't complete request, kindly try again", "Warning!");
                }
            })
        }
    },
    created: function(){
        localStorage.setItem("cn_prv_page","cnsurveys");//log current page
        // this.preset();
        this.preset2();
        // this.getSurveys(0,this.pag_intv);

     }
}


// WEBPACK FOOTER //
// ./src/components/Cnsurveys/script.js